<template>
  <vue-glow
    :color="value ? '#42A5F6' : '#FF0000'"
    :elevation="4"
    :intensity="2"
    intense
    mode="hex"
  >
    <v-card
      class="pa-3"
      outlined
      tile
    >
      <v-card
        flat
        outlined
        tile
      >
        <div
          :class="value && 'grey lighten-4'"
          class="pa-6 pb-12 mb-8"
        >
          <v-row justify="center">
            <base-title
              :title="title"
              class="text-uppercase"
              space="1"
              size="subtitle-1"
            />
            <v-tooltip
              max-width="400"
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="grey lighten-1">
                    mdi-information-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ titleDescription }}</span>
            </v-tooltip>
          </v-row>

          <base-subtitle
            :title="subtitle"
            space="4"
          />

          <div>
            <div class="text-center ml-4 body-4 font-weight-bold mt-1 text-uppercase text-">
              Total Savings
              <span v-visible="value">
                <v-tooltip
                  max-width="400"
                  right
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="grey lighten-1">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Total savings over 30 years compared to the other guys loan, which is a conventional 30
                    year amortized loan at today's estimated market rate.</span>
                </v-tooltip>
              </span>

              <base-divider
                align="center"
                color="primary"
                space="0"
              />
            </div>
          </div>

          <div class="d-flex align-center justify-center">
            <base-heading
              mobile-size="display-2"
              space="0"
              tag="h3"
            >
              <sup><small><small>$</small></small></sup><small />
              <animated-number
                :value="totalSavings"
                :format-value="formatToPrice"
                :duration="1000"
              />
            </base-heading>
          </div>
        </div>

        <div class="mb-8" />

        <div class="pb-12">
          <div class="px-8 mb-1">
            <div
              class="my-3"
              v-text="feature.monthlyPayment"
            />
            <v-divider />
            <div
              class="my-3"
              v-text="feature.term"
            />
            <v-divider />
            <div
              class="my-3"
              v-text="feature.rate"
            />
            <v-divider />
            <div
              class="my-3"
              v-text="feature.loanAmountTotal"
            />
            <v-divider />
            <div
              class="my-3"
              v-text="feature.loanAmountPaidTotal"
            />
          </div>
          <v-col>
            <base-btn
              v-visible="link"
              class="mb-n6"
              :color="value ? 'primary' : 'accent'"
              :outlined="!value"
              width="196"
              :to="{ name: 'Loan Application' }"
            >
              Apply Now
            </base-btn>
          </v-col>
          <v-col class="mb-n12">
            <v-btn
              v-visible="link"
              text
              color="blue"
              :to="{name: 'Basic Estimate' }"
              target="_blank"
            >
              Get Estimate
              <v-icon>
                mdi-open-in-new
              </v-icon>
            </v-btn>
          </v-col>
        </div>
      </v-card>
      <div>
        <v-dialog
          v-model="dialog"
          width="800"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="blue"
              dark
              text
              v-bind="attrs"
              v-on="on"
            >
              <small>
                Amortization Schedule
              </small>
              <v-icon>
                mdi-arrow-up-right
              </v-icon>
            </v-btn>
          </template>
          <v-row>
            <v-col
              style="background-color: white"
              cols="12"
            >
              <v-card
                style="padding: 10px; margin-left: 10px"
              >
                <v-card-title class="headline grey lighten-2">
                  Breakeven
                </v-card-title>
                <div>
                  <div
                    id="chart"
                    style="min-height: 454px"
                  >
                    <apexchart
                      type="line"
                      :options="chartOptions"
                      :series="chartSeries"
                    />
                  </div>
                  <div>
                    <v-overlay
                      :value="loading"
                      absolute
                    >
                      <v-progress-circular
                        indeterminate
                        size="64"
                      />
                    </v-overlay>
                  </div>
                </div>

                <v-card
                  style="padding: 10px; margin-left: 10px"
                >
                  <p>
                    Heq Breakeven Point: <strong>{{ breakEvenMonths[0] }}</strong> months
                  </p><p />
                  <p>
                    Standard Breakeven Point: <strong>{{ breakEvenMonths[1] }}</strong> months
                  </p>
                  <p>
                    Mirror breakeven point: <strong>{{ breakEvenMonths[2] }}</strong> months
                  </p>
                </v-card>
              </v-card>
            </v-col>
            <v-col
              style="background-color: white"
            >
              <v-card
                style="padding: 10px; margin-left: 10px"
              >
                <v-card-title class="headline grey lighten-2">
                  Amortization Schedule
                </v-card-title>
                <v-col>
                  <v-simple-table>
                    <thead>
                      <tr />
                    </thead>

                    <tbody class="body-1">
                      <tr
                        v-for="([idx, payment, one, two, three], i) in amSchedule"
                        :key="i"
                      >
                        <td class="text-center font-weight-bold">
                          {{ idx }}
                        </td>
                        <template v-if="i === 0">
                          <td class="text-center font-weight-bold">
                            {{ payment }}
                          </td>
                          <td class="text-center font-weight-bold">
                            {{ one }}
                          </td>
                          <td class="text-center font-weight-bold">
                            {{ two }}
                          </td>

                          <td class="text-center font-weight-bold">
                            {{ three }}
                          </td>
                        </template>
                        <template v-else>
                          <td class="text-center">
                            {{ formatCurrency(payment) }}
                          </td>
                          <td class="text-center">
                            {{ formatCurrency(one) }}
                          </td>

                          <td class="text-center">
                            {{ formatCurrency(two) }}
                          </td>
                          <td class="text-center">
                            {{ formatCurrency(three) }}
                          </td>
                        </template>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>

                <v-divider />

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="dialog = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-dialog>
      </div>
    </v-card>
  </vue-glow>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'
  import VueGlow from 'vue-glow'

  export default {
    name: 'LoanEstimateCard',
    components: {
      AnimatedNumber,
      VueGlow,
    },

    props: {
      totalSavings: Number,
      link: Boolean,
      subtitle: String,
      title: String,
      titleDescription: String,
      value: Boolean,
      feature: Object,
      estimateData: Object,
      amSchedule: Array,
      amAll: Array,
    },

    data () {
      return {
        loading: true,
        dialog: false,
        // options: {
        //   chart: {
        //     id: 'breakeven-chart',
        //   },
        //   xaxis: {
        //     categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
        //   },
        // },
        // series: [
        //   {
        //     name: 'heq',
        //     data: [70, 80, 45, 40, 41, 38, 44, 50],
        //   },
        //   {
        //     name: 'other',
        //     data: [30, 40, 45, 50, 49, 60, 70, 91],
        //   },
        // ],
      }
    },

    computed: {

      breakEvenMonths () {
        const balances = this.getBalances()
        const months = [0, 0, 0]
        // let months = 0

        for (let i = 0; i < months.length; i++) {
          for (let j = 0; j < balances[i].length; j++) {
            if (balances[i][j] < balances[3][j]) {
              months[i] = j + 1
              break
            }
          }
        }
        return months
      },

      chartOptions () {
        const paymentNumbers = []
        let maxId = 0
        let max = 0
        for (let i = 0; i < this.amAll.length; i++) {
          if (this.amAll[i].length > max) {
            max = this.amAll[i].length
            maxId = i
          }
        }
        for (let i = 0; i < this.amAll[maxId].length; i++) {
          paymentNumbers.push(Number.parseInt(this.amAll[maxId][i][0]))
        }
        return {
          chart: {
            id: 'breakeven-chart',
            type: 'line',
            height: 400,
            events: {
              mounted: (e, chartContext) => {
                console.log('in mounted')
              },
              beforeMount: (e, chartContext) => {
                console.log('in beforeMount')
              },
              updated: (e, chartContext) => {
                console.log('in updated')
                this.loading = false
              },

            },
          },
          colors: ['#009FFD', '#FFE74C', '#57CC99', '#FE654F'],
          xaxis: {
            categories: paymentNumbers,
            tickAmount: 10,
            min: 2,
          },
          markers: {
            size: 0,
          },
          stroke: {
            curve: 'smooth',
            width: 6,
          },
          fill: {
            type: 'solid',
          },
          title: {
            text: 'Remaining Balance by Month',
            align: 'center',
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
        }
      },

      chartSeries () {
        const balances = []
        for (let i = 0; i < this.amAll.length; i++) {
          balances.push([])
          for (let j = 0; j < this.amAll[i].length; j++) {
            balances[i].push(Number.parseInt(this.amAll[i][j][4]))
          }
        }

        return [
          {
            name: 'Heq',
            data: balances[0],
          },
          {
            name: 'Standard',
            data: balances[1],
          },
          {
            name: 'Mirror',
            data: balances[2],
          },
          {
            name: 'Other',
            data: balances[3],
          },
        ]
      },
    },

    // watch: {
    //   loading (val) {
    //     val && setTimeout(() => {
    //       this.loading = false
    //     }, 3000)
    //   },
    // },

    provide: {
      heading: { align: 'center' },
    },

    methods: {
      whatever () {
        alert('hello asdfasdfasdf')
      },
      formatToPrice (value) {
        return value.toFixed().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      getEstimate () {
        const url = this.$router.resolve({
          name: 'Basic Estimate',
          query: {
            ...this.estimateData,
          },
        })
        window.open(url.href, '_blank')
      },

      getBalances () {
        // this.loading = true
        const balances = []
        for (let i = 0; i < this.amAll.length; i++) {
          balances.push([])
          for (let j = 0; j < this.amAll[i].length; j++) {
            balances[i].push(Number.parseInt(this.amAll[i][j][4]))
          }
        }
        return balances
      },

      formatCurrency (amount) { // https://stackoverflow.com/questions/149055/how-to-format-numbers-as-currency-string
        try {
          const decimalCount = 0
          const negativeSign = amount < 0 ? '-' : ''

          const i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString()
          const j = (i.length > 3) ? i.length % 3 : 0

          return '$' + negativeSign + (j ? i.substr(0, j) + ',' : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + ',')
        } catch (e) {
        }
      },
    },
  }
</script>
